// extracted by mini-css-extract-plugin
export var body = "_2i-8";
export var button = "_2i-0";
export var closeButton = "_2i-5";
export var content = "_2i-3";
export var empty = "_2i-f";
export var grid = "_2i-c";
export var header = "_2i-4";
export var icon = "_2i-1";
export var option = "_2i-d";
export var optionSelected = "_2i-e";
export var overlay = "_2i-2";
export var searchIcon = "_2i-a";
export var searchInput = "_2i-b";
export var searchWrapper = "_2i-9";
export var title = "_2i-6";
export var visuallyHidden = "_2i-7";